<template>
  <div class="card mt-1 no-mobile">
    <div class="table-controls m-3">
      <div class="controls-wrap d-flex align-items-center">
        <Search placeholderText="Search (title and description)" @search="doSearch" />
        <!--   <div class="ms-auto buttons">
          <button
            v-if="
              (getManagerUserProfile.employer_freelancers === 2 ||
                getManagerUserProfile.employer_freelancers === 3) &&
                getManagerUserProfile.employer_registration_number
            "
            type="button"
            class="btn btn-success text-nowrap ml-auto mr-3"
            @click="showModalFreeLancer = true"
          >
            Find Freelancer
            <portal to="add-job-modal-freelancer">
              <CustomMainModal
                @close="onCloseAddManagerJobModalFreeLancer"
                v-show="showModalFreeLancer"
              >
                <template v-slot:header>
                  <h5>Find Freelancer</h5>
                </template>
                <AddManagerFreeLancerBtnModal
                  :userProfile="getManagerUserProfile"
                  v-if="showModalFreeLancer"
                />
              </CustomMainModal>
            </portal>
          </button>

          <button
            v-else
            type="button"
            class="btn btn-success text-nowrap ml-auto mr-3"
            data-toggle="modal"
            data-target=".bd-like-btn"
          >
            Find Freelancer
          </button>

          <button
            type="button"
            class="btn btn-success text-nowrap"
            :class="getManagerUserProfile.employer_freelancers !== 1 ? '' : 'ms-auto'"
            @click="showModal = true"
          >
            Add Job
            <portal to="add-job-modal">
              <CustomMainModal @close="onCloseAddManagerJobModal" v-show="showModal">
                <template v-slot:header>
                  <h5>{{ modalTitle }}</h5>
                </template>
                <AddManagerJobBtnModal
                  :userProfile="getManagerUserProfile"
                  v-if="showModal"
                  @step="changeHeader($event)"
                />
              </CustomMainModal>
            </portal>
          </button>
          <portal-target name="add-job-modal"></portal-target>
          <portal-target name="add-job-modal-freelancer"></portal-target>
        </div> -->
      </div>
    </div>

    <Spinner :isLoading="isLoading" />
    <div
      class="table-responsive hide-on-mobile"
      :style="getManagerJobs.length === 0 ? 'overflow-y:hidden; padding-bottom:15px' : ''"
    >
      <table class="table table-striped custom-table desktop-only-table">
        <thead class="bg-dark">
          <tr>
            <th id="col-title" style="width: 240px" class="extend-on-bigscreen" scope="col" nowrap>
              TITLE
            </th>
            <th nowrap style="width: 180px" class="extend-on-bigscreen" scope="col">LOCATION</th>
            <th nowrap style="width: 80px; text-align: center" scope="col">&nbsp;</th>
            <th nowrap scope="col" class="extend-on-bigscreen">UPDATED</th>
            <th nowrap scope="col" class="extend-on-bigscreen">STATUS</th>
            <th nowrap scope="col">PIPELINE STATISTICS</th>
          </tr>
        </thead>
        <tbody style="position: relative; z-index: 50">
          <tr v-for="job in getManagerJobs" :key="job.id">
            <td id="title" nowrap>
              <div class="truncate-item">
                <div slot="reference">
                  <router-link
                    :title="job.title"
                    :to="{
                      name: 'manager_job_uuid',
                      params: { manager_job_uuid: job.id, job_name: job.title },
                    }"
                  >
                    {{ job.title }}
                  </router-link>
                </div>
              </div>
            </td>
            <td id="location" nowrap style="overflow: hidden; text-overflow: ellipsis">
              {{ getLocation(job) }}
            </td>
            <td id="service-level" class="p-0" nowrap>
              <div class="popover-show mx-auto" style="width: 25px; height: auto">
                <svgHelper
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="serviceLevel(job.service_level).title"
                  :name="serviceLevel(job.service_level).title"
                ></svgHelper>
              </div>
            </td>

            <td nowrap id="updated-at">
              <popper
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '-170px,10px' } },
                }"
              >
                <div class="popper">
                  {{
                    job.updated_at
                      | formatDate({
                        format: getManagerUserProfile.format_date,
                        timezone: getManagerUserProfile.timezone,
                        hasHourAndMinutes: true,
                      })
                  }}
                </div>
                <div slot="reference">
                  {{
                    job.updated_at
                      | formatDate({
                        format: getManagerUserProfile.format_date,
                        timezone: getManagerUserProfile.timezone,
                        hasHourAndMinutes: false,
                      })
                  }}
                </div>
              </popper>
            </td>

            <td id="status" align="center">
              <div class="d-flex align-items-center">
                <div
                  :class="[
                    getStatusColorClass(job.status),
                    'flex-shrink-0',
                    'stage-size',
                    'rounded-circle',
                    'mr-2',
                  ]"
                ></div>
                <span
                  :class="[
                    getStatusTitle(job.status).status !== '' ? 'text-nowrap' : 'mr-0',
                    'stage-text',
                  ]"
                  >{{ getStatusTitle(job.status).status }}</span
                >
              </div>
            </td>
            <td id="pipeline-statistics">
              <!-- TODO: integrate custom statistics component -->
              <!--  <PipelineStats
                :statistics="[{ id: 1, num: 21, label: 'Not contacted' }]"
              ></PipelineStats> -->
              <ul
                v-if="job.statistics.length !== 0"
                class="stats-labels d-none d-sm-none d-xs-none d-md-none d-lg-none d-xl-flex"
              >
                <li
                  v-show="job.statistics.hasOwnProperty(102)"
                  class="stats-labels-item color-grey"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Not contacted</div>
                    <router-link to slot="reference" class="text-white">{{
                      job.statistics[102]
                    }}</router-link>
                  </popper>
                </li>
                <li
                  v-show="job.statistics.hasOwnProperty(103)"
                  class="stats-labels-item color-light-grey"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Contacted</div>
                    <router-link to href slot="reference" class="text-white">{{
                      job.statistics[103]
                    }}</router-link>
                  </popper>
                </li>
                <li
                  v-show="job.statistics.hasOwnProperty(104)"
                  class="stats-labels-item color-blue"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Interviewing</div>
                    <router-link to href slot="reference" class="text-white">{{
                      job.statistics[104]
                    }}</router-link>
                  </popper>
                </li>
                <li
                  v-show="job.statistics.hasOwnProperty(106)"
                  class="stats-labels-item color-light-blue"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Offered employment</div>
                    <router-link to href slot="reference" class="text-white">{{
                      job.statistics[106]
                    }}</router-link>
                  </popper>
                </li>
                <li
                  v-show="job.statistics.hasOwnProperty(107)"
                  class="stats-labels-item color-green"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Employed</div>
                    <router-link to href slot="reference" class="text-white">{{
                      job.statistics[107]
                    }}</router-link>
                  </popper>
                </li>
                <!-- <li
                  v-show="job.statistics.hasOwnProperty(109)"
                  class="stats-labels-item color-red"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Not in consideration</div>
                    <router-link to href slot="reference" class="text-white">{{
                      job.statistics[109]
                    }}</router-link>
                  </popper>
                </li> -->
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div @scroll="onScroll" class="mobile-list">
      <ul class="list-unstyled">
        <li class="mobile-list-item" v-for="job in lazyLoadJobs" :key="job.id">
          <div class="header">
            <div class="title">
              <router-link
                :title="job.title"
                :to="{
                  name: 'manager_job_uuid',
                  params: { manager_job_uuid: job.id, job_name: job.title },
                }"
              >
                {{ job.title }}
              </router-link>
              <div class="location">{{ getLocation(job) }}</div>
            </div>
            <div class="date">
              {{
                job.updated_at
                  | formatDate({
                    format: getManagerUserProfile.format_date,
                    timezone: getManagerUserProfile.timezone,
                    hasHourAndMinutes: false,
                  })
              }}
              <div class="d-flex align-items-center">
                <div
                  :class="[
                    getStatusColorClass(job.status),
                    'flex-shrink-0',
                    'stage-size',
                    'rounded-circle',
                    'mr-2',
                    'ml-auto',
                  ]"
                ></div>
                <span
                  :class="[
                    getStatusTitle(job.status).status !== '' ? 'text-nowrap' : 'mr-0',
                    'stage-text',
                  ]"
                  >{{ getStatusTitle(job.status).status }}</span
                >
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!--     <ErrorList
      class="no-data-message"
      v-show="getManagerJobs.length == 0"
      name="noJobs"
      :phrase="searchText"
    /> -->

    <div v-show="getManagerJobs.length == 0 && !isLoading" class="welcome-text">
      <h3>Your posted jobs, along with their statuses and statistics, will be shown here.</h3>
    </div>
    <Spinner :isLoading="isLoading" />

    <div class="bottom-controls ml-auto mt-auto w-10">
      <div id="pagination">
        <!-- Pagination -->
        <Pagination
          :currentPage="getCurrentPage"
          :totalPages="getTotalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @keyup="keymonitor"
          @selectPageByNumber="setPageBynumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
        ></Pagination>
      </div>
    </div>

    <div v-if="intro" class="on-exit animate__animated animate__fadeIn animate__fast">
      <div class="box">
        <div class="content">
          <span @click="hideIntro" class="close-button">X</span>
          <div class="text">
            <h3>Welcome to Jobshark!</h3>
            <p>
              We're thrilled to have you onboard. Jobshark is a unique, cloud-based platform
              designed to streamline your entire process of finding and hiring top IT talent. Our
              dedicated team of tech recruiters works efficiently behind the scenes, sourcing,
              vetting, and coordinating with candidates to ensure a seamless experience for you.
            </p>
            <h4>We offer two primary solutions to meet your needs:</h4>
            <ul class="list-unstyled">
              <li>
                <strong>Tech Recruiting:</strong> We assist you in finding and hiring permanent
                employees to strengthen your team.
              </li>
              <li>
                <strong>Freelancing Network:</strong> We connect you with highly skilled freelancers
                who can work remotely on your projects.
              </li>
            </ul>
            <p>
              Choose the service that best fits your needs and follow our step-by-step guides to
              request the competence you need.
            </p>
          </div>
          <div class="img-holder">
            <img src="https://jobshark.eu/img/shark_welcome.png" alt="welcome shark" />
          </div>
        </div>
        <div class="d-flex align-items-center buttonss" style="gap: 12px;">
          <button @click="toggleModals('tech')" class="btn btn-secondary">
            Tech Recruiting
          </button>
          <button @click="toggleModals('free')" class="btn btn-secondary">
            Find Freelancers
          </button>
          <div @click="hideIntro" class="btn btn-danger" style="margin-left: auto;">
            <span>Close</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { statusMapper } from '@/utils/helpers';

import { mapGetters, mapActions } from 'vuex';

import Pagination from '@/components/Navigations/Pagination';

import Search from '../../common/Search/Search';
import AddManagerJobBtnModal from './AddManagerJobBtnModal';
import AddManagerFreeLancerBtnModal from './AddManagerFreeLancerBtnModal';
import CustomMainModal from '../../Modals/CustomMainModal';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { statusMixin } from '../../../mixins/statusMixin';
import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import titleMixin from '../../../mixins/titleMixin';
import { errorService } from '../../../services/errorService';
import ErrorList from '@/components/common/errorsList';
import axios from 'axios';
import Spinner from '../../common/LoadingSpinner/Spinner.vue';

export default {
  props: {
    isVisible: {
      type: String,
      default: '',
    },
  },
  mixins: [
    stagesMixin,
    statusMixin,
    displayResultsBasedOnScreenHeightMixin,
    serviceLevelMixin,
    titleMixin,
  ],
  title() {
    return 'Jobs | Jobshark';
  },
  components: {
    Pagination,
    Search,
    ErrorList,
    AddManagerJobBtnModal,
    AddManagerFreeLancerBtnModal,
    CustomMainModal,
  },
  data: () => ({
    intro: false,
    searchText: '',
    /*    modalTitle: 'Add Job - Choose Recruitment Plan', */
    infiniteScrollList: [],
    /*  showModal: false,
    showModalFreeLancer: false, */
    currentPage: 1,
    pageCount: 10,
    isLoading: true,
    listOfSelectedJobs: [],
    lazyLoadJobs: [],
  }),
  methods: {
    ...mapActions('managerStoreModule', [
      'retrieveManagerJobs',
      'retrieveManagerUserProfile',
      'setGuideStep',
    ]),
    onCloseAddManagerJobModal() {
      this.showModal = false;
    },

    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.currentPage++;
        this.retrieveManagerJobs({
          page: this.currentPage,
          count: this.pageCount,
        }).then(() => {
          this.lazyLoadJobs = [...this.lazyLoadJobs, ...this.getManagerJobs];
        });
      }
    },

    hideIntro() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/manager/updateintroscreen`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.intro = false;
        });
    },

    toggleModals(modal) {
      if (modal === 'tech') {
        this.showModal = true;
        this.$emit('modal', modal);
      }
      if (modal === 'free') {
        this.showModalFreeLancer = true;
        this.$emit('modal', modal);
      }
      this.intro = false;
    },

    /*     changeHeader(ev) {
      if (ev === 0) {
        this.modalTitle = 'Add Job - Choose Recruitment Plan';
      }
      if (ev === 1) {
        this.modalTitle = 'Add Job';
      }
    },
    onCloseAddManagerJobModalFreeLancer() {
      this.showModalFreeLancer = false;
    }, */
    doSearch(searchedText) {
      this.currentPage = 1;

      if (searchedText.length >= 3) {
        this.isLoading = true;
        this.searchText = searchedText;

        this.retrieveManagerJobs({
          search_word: searchedText,
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(() => {
            this.lazyLoadJobs = this.getManagerJobs;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }

      if (searchedText === '') {
        this.isLoading = true;
        this.searchText = searchedText;

        this.retrieveManagerJobs({
          search_word: searchedText,
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
            this.lazyLoadJobs = this.getManagerJobs;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    nextPage() {
      if (this.currentPage >= 1 && this.currentPage < this.getTotalPages) {
        this.isLoading = true;
        this.currentPage++;

        this.retrieveManagerJobs({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.retrieveManagerJobs({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.retrieveManagerJobs({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.retrieveManagerJobs({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;

      this.retrieveManagerJobs({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    getLocation(job) {
      if (job.city.name && job.country.name) {
        return `${job.city.name}, ${job.country.name}`;
      }

      return 'N/A';
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight' && !this.showModal && !this.showModalFreeLancer) {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft' && !this.showModal && !this.showModalFreeLancer) {
        this.previousPage();
      }
    },
  },
  watch: {},
  computed: {
    ...mapGetters('managerStoreModule', [
      'getManagerUserProfile',
      'getManagerProfile',
      'getManagerJobs',
      'getCurrentPage',
      'getTotalPages',
    ]),
    getStatus() {
      return statusMapper('6');
    },
  },
  mounted() {
    /*  this.displayResultsBasedOnScreen(); */

    this.retrieveManagerUserProfile().then(() => {
      if (!this.getManagerUserProfile.intro_screen) {
        this.intro = true;
      }
      if (this.getManagerUserProfile.guide_screen) {
        if (window.innerWidth > 1251) {
          this.$store.commit('managerStoreModule/SET_GUIDE_SHOW', true);
        } else {
          this.setGuideStep(3);
          this.$store.commit('managerStoreModule/SET_GUIDE_SHOW', true);
        }
      }
    });
    this.retrieveManagerJobs({ page: this.currentPage, count: this.pageCount }).then(
      () => ((this.isLoading = false), (this.lazyLoadJobs = this.getManagerJobs)),
    );
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_mixins.scss';

.welcome-text {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  h3 {
    width: 35%;
    color: #666;
  }
}

.on-exit {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  padding-top: 50px;
  padding-bottom: 50px;
  overflow-y: auto;
  .box {
    width: 55%;
    max-width: 1250px;
    background: #fff;
    border-radius: 22px;
    border: 1px solid #ddd;
    padding: 22px;
    position: relative;
    background-color: #fff;
    .content {
      position: relative;
      display: flex;
      .close-button {
        position: absolute;
        top: 0px;
        right: 20px;
        cursor: pointer;
        font-weight: 900;
        color: #666;
      }
      .text {
        padding: 30px 20px 30px 0;
        flex: 1;
        flex-shrink: 0;
        h3 {
          font-weight: 900;
          color: #f26622;
          font-size: 26px;
          margin-bottom: 20px;
        }
        h4 {
          font-size: 16px;
          font-weight: 700;
        }
        p {
          font-size: 15px;
        }
        .list-unstyled {
          list-style: disc !important;
          font-size: 15px;
          padding-left: 25px;
          li {
            margin-bottom: 12px;
            font-size: 14px;
          }
        }
        .btn-secondary {
          padding: 8px 30px;
          font-size: 16px;
          font-weight: 500;
          flex: 1;
          &:first-of-type {
            margin-right: 12px;
          }
        }
      }
      .img-holder {
        flex: 1;
        align-self: center;
        img {
          width: 100%;
          height: auto;
        }
      }
      .dont {
        text-align: center;
        margin-top: 12px;
        font-size: 13px;
        color: rgb(0, 136, 204);
        cursor: pointer;
      }
    }
  }
}

.custom-label {
  line-height: 40px;
  position: absolute;
  right: 70px;
  top: 0;
  bottom: 0;
  -moz-transition: 0.3s right ease;
  -ms-transition: 0.3s right ease;
  -o-transition: 0.3s right ease;
  -webkit-transition: 0.3s right ease;
  transition: 0.3s right ease;
  z-index: 0;
}

.btn-success {
  align-self: start;
}

.m-button {
  display: none;
}

.published {
  margin-top: 8px;
}

.truncate-item {
  a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
}

.custom-table {
  min-width: 100%;
  tr {
    td {
      &:first-of-type {
        padding-left: 21px;
      }
    }
  }
}

.table-responsive {
  overflow-y: auto;
}

select {
  min-width: 110px;
  box-shadow: 0px 2px 3px #0000000d;
  border: 1px solid #d7dae2;
  border-radius: 4px;
}

#stage {
  .stage-size {
    width: 12px;
    height: 12px;
  }

  .stage-color-new {
    background-color: #4ca7d5;
  }
  .stage-color-draft {
    background-color: #8a8b8a;
  }
  .stage-color-active {
    background-color: #419941;
  }
  .stage-color-expired {
    background-color: #f17931;
  }
  .stage-color-rejected {
    background-color: #f02800;
  }
}

/* Pipeline statistics */
#pipeline-statistics {
  position: relative;

  .stats-labels {
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate(0%, -50%);
    opacity: 0.75;
    list-style-type: none;
    margin: 0;
    padding: 0;
    font-family: Lato;
    font-size: 11px;

    .stats-labels-item {
      span {
        padding: 5px;
        color: #fff;
      }

      // float: left;
      clip-path: polygon(85% 0, 100% 50%, 85% 100%, 0 100%, 10% 50%, 0 0);
      // height: 8px;
      padding: 0.4rem 1rem 0.4rem 1rem;
      margin-right: -10px;
    }

    .color-grey {
      background: #333;
    }

    .color-light-grey {
      background: #747674;
    }

    .color-blue {
      background: #465c74;
    }

    .color-light-blue {
      background: #066da1;
    }

    .color-green {
      background: #148214;
    }

    .color-light-green {
      background: #5bb75b;
    }

    .color-dark-red {
      background: #913d8b;
    }

    .color-red {
      background: #f02800;
    }

    span:nth-child(1) {
      font-size: 14px;
      font-weight: bold;
      margin-right: 10px;
    }

    span:nth-child(2) {
      font-weight: 300;
    }
  }
}

/* #col-title,
#title:not([data-scroll='0']) {
  -webkit-box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
} */
.published-mobile {
  display: none !important;
}

.employer-select {
  flex: 1;
}

.mobile-only {
  display: none !important;
}

.desktop-only {
  display: block;
}
.desktop-only-table {
  display: table;
}
.service-level-select,
.employer-level-select {
  width: 50%;
}

.card {
  height: 81.7vh;
  padding-bottom: 0 !important;
}

.mobile-list {
  display: none;
}

@media only screen and (min-width: 2100px) {
  .extend-on-bigscreen {
    width: 320px !important;
  }
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 1600px) {
  .welcome-text {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    h3 {
      width: 90%;
      color: #666;
    }
  }
  .on-exit {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    padding-top: 50px;
    padding-bottom: 50px;
    overflow-y: auto;
    .box {
      height: auto;
      background: #fff;
      border-radius: 22px;
      border: 1px solid #ddd;
      padding: 22px;
      position: relative;
      background-color: #fff;
      .content {
        position: relative;
        display: block;
        .close-button {
          position: absolute;
          top: 0px;
          right: 20px;
          cursor: pointer;
          font-weight: 900;
          color: #666;
        }
        .text {
          padding: 30px 20px 30px 0;
          flex: 1;
          flex-shrink: 0;
          h3 {
            font-weight: 900;
            color: #f26622;
            font-size: 18px;
            margin-bottom: 20px;
          }
          h4 {
            font-size: 14px;
            font-weight: 700;
          }
          p {
            font-size: 14px;
          }
          .list-unstyled {
            list-style: disc !important;
            font-size: 14px;
            padding-left: 25px;
            li {
              margin-bottom: 12px;
              font-size: 14px;
            }
          }
          .buttonss {
            display: block !important;
          }
          .btn-secondary {
            padding: 8px 30px;
            font-size: 16px;
            font-weight: 500;
            display: block;
            width: 100%;
            &:first-of-type {
              margin-right: 12px;
              margin-bottom: 15px;
            }
          }
        }
        .img-holder {
          display: none;
        }
        .dont {
          text-align: center;
          margin-top: 12px;
          font-size: 13px;
          color: rgb(0, 136, 204);
          cursor: pointer;
        }
      }
    }
  }

  .m-button {
    display: inline-block;
    margin-top: 12px;
  }
  .card {
    margin-top: 26px !important;
    border-top-left-radius: 18px !important;
    border-top-right-radius: 18px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .custom-table {
    display: table;
  }
  .mobile-only {
    display: block !important;
  }
  .integration-group {
    margin: 0 !important;
  }
  .controls-wrap {
    display: flex !important ;
    .form-control {
      flex: 1;
    }
    .published {
      display: none !important;
    }
    .published-mobile {
      display: inline-block !important;
    }
    .employer-select {
      width: 100% !important;
    }
    .form-control:first-child {
      margin: 15px 17px 15px 0 !important;
    }
  }
  .desktop-only {
    display: none;
  }

  .wrapper {
    width: 100%;
  }
  .service-level-select {
    margin-top: 12px;
  }
  .employer-level-select {
    margin-top: 12px;
  }
}

@media only screen and (max-width: 920px) {
  .on-exit {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    padding-top: 50px;
    padding-bottom: 50px;
    overflow: hidden;
    .box {
      height: 95%;
      width: 95%;
      background: #fff;
      border-radius: 22px;
      border: 1px solid #ddd;
      padding: 22px;
      position: relative;
      background-color: #fff;
      overflow: hidden;
      overflow-y: auto;
      .content {
        position: relative;
        display: block;
        .close-button {
          position: absolute;
          top: 0px;
          right: 20px;
          cursor: pointer;
          font-weight: 900;
          color: #666;
        }
        .text {
          padding: 30px 20px 30px 0;
          flex: 1;
          flex-shrink: 0;
          h3 {
            font-weight: 900;
            color: #f26622;
            font-size: 18px;
            margin-bottom: 20px;
          }
          h4 {
            font-size: 14px;
            font-weight: 700;
          }
          p {
            font-size: 14px;
          }
          .list-unstyled {
            list-style: disc !important;
            font-size: 14px;
            padding-left: 25px;
            li {
              margin-bottom: 12px;
              font-size: 14px;
            }
          }
          .buttonss {
            display: block !important;
          }
          .btn-secondary {
            padding: 8px 30px;
            font-size: 16px;
            font-weight: 500;
            display: block;
            width: 100%;
            &:first-of-type {
              margin-right: 12px;
              margin-bottom: 15px;
            }
          }
        }
        .img-holder {
          display: none;
        }
        .dont {
          text-align: center;
          margin-top: 12px;
          font-size: 13px;
          color: rgb(0, 136, 204);
          cursor: pointer;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .card {
    margin-top: 24px !important;
  }
  .custom-table {
    display: table;
  }
  .mobile-only {
    display: block !important;
  }
  .integration-group {
    margin: 0 !important;
  }
  .controls-wrap {
    display: flex !important ;
    .form-control {
      flex: 1;
    }
    .published {
      display: none !important;
    }
    .published-mobile {
      display: inline-block !important;
    }
    .employer-select {
      width: 100% !important;
    }
    .form-control:first-child {
      margin: 15px 17px 15px 0 !important;
    }
  }
  .desktop-only {
    display: none;
  }

  .service-level-select,
  .employer-level-select {
    width: 100%;
  }

  .bottom-controls {
    position: relative;
    top: 0;
    bottom: 0 !important;
    .ml-auto {
      margin-left: auto !important;
    }
    margin-right: auto !important;
  }

  .hide-on-mobile {
    display: none;
  }

  .mobile-list {
    display: block;
    overflow-y: auto;
    .mobile-list-item {
      padding: 18px;
      border-bottom: 3px solid rgb(233, 233, 233);
      font-family: Lato, Roboto, 'Helvetica Neue', Arial, sans-serif;
      .header {
        display: flex;
        justify-content: space-between;
        a {
          font-weight: 600;
        }
        .location {
          font-size: 14px;
        }
        .date {
          font-size: 14px;
          text-align: right;
        }
      }
    }
  }
}
@media only screen and (max-width: 576px) {
  .no-data-message {
    display: none;
  }
  .bottom-controls {
    display: none !important;
  }
  .card {
    margin-top: 0px !important;
  }
  .custom-table {
    display: block;
  }
  .integration-group {
    margin: 0 !important;
  }
  .controls-wrap {
    display: flex !important ;
    flex-wrap: wrap;
    .form-control {
      flex: 1;
      order: 2;
    }
    .published {
      display: none !important;
    }
    .published-mobile {
      display: inline-block !important;
    }
    .employer-select {
      width: 100% !important;
    }
    .form-control:first-child {
      margin: 15px 0px 15px 0 !important;
    }
    .buttons {
      display: flex;

      width: 100%;
      flex-shrink: 0;
      .btn-success {
        flex: 1;
      }
    }
  }
  .mobile-only {
    display: block !important;
  }
  .service-level-select {
    margin-right: 0 !important;
  }
}

@media screen and (max-width: 1200px) {
  .stats-labels-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.vs--searchable .vs__dropdown-toggle {
  height: calc(1.5em + 0.75rem + 2px);
}

.col-md-8.filter {
  color: #6c757d;
  margin-bottom: 12px;
  font-family: $font-family-sans-lato;
}

.filter-select {
  min-width: 200px;
  max-width: 200px;
  margin-right: 6px !important;
  padding-bottom: 8px;
}

@media only screen and (max-width: 992px) {
  .buttonss {
    display: block !important;
    .btn {
      display: block;
      width: 100%;
      margin-bottom: 12px;
    }
  }
}
</style>
